import { Link } from 'react-router-dom';

/** T-196: the site footer. There was NO footer component in this codebase before this
 *  commit — components/layout/ held Header, Sidebar and RightSidebar only. The T-196
 *  requirement "compliance pages with footer links" was therefore build-a-footer, not
 *  wire-up-links: a policy page nothing links to is not published.
 *
 *  MOUNT POINT MATTERS. This renders INSIDE <main>, after <Outlet />, not as a sibling
 *  of the header/sidebar row. `main` is `overflow-auto` — its own scroll container — so
 *  a footer placed as a sibling would be pinned to the viewport bottom on every page
 *  forever instead of sitting at the end of the document. Keep it inside main.
 */
const LINKS = [
  { to: '/about', label: 'About' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/contact', label: 'Contact' },
];

export function Footer() {
  return (
    <footer className="mt-12 border-t border-border-primary px-6 py-8">
      <div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <nav aria-label="Footer" className="flex flex-wrap items-center gap-x-5 gap-y-2">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-[12px] font-normal text-text-tertiary transition-colors hover:text-text-primary"
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <p className="text-[12px] font-normal text-text-tertiary">
          &copy; {new Date().getFullYear()} MotoWalla
        </p>
      </div>
    </footer>
  );
}
